import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import CVVideo from '../models/cv-video';
import AcceptanceCvVideoDto from '../models/dto/acceptance-cv-video-dto';
import ICVvideosPaginatedesponse from '../models/dto/paginated-reponse';
import VideoModerationResultDto from '@cv-videos/models/dto/video-moderation-result.dto';
import TextModerationResponseDto from '@cv-videos/models/dto/text-moderation-response.dto';

export const getCVVideos = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<ICVvideosPaginatedesponse<CVVideo>>> => {
  return await axiosClient.post(
    EndPoints.cvVideos.getCVVideos(paginatedParams),
    searchCriteria,
  );
};

export const getCVVideosCount = async (): Promise<number> => {
  const response = await axiosClient.post(
    EndPoints.cvVideos.getCVVideos({ page: 1 }),
    { searchCriteria: [] },
  );
  return response.data.meta.cvVideoPendingCount;
};

export const getCVVideoById = async (
  id: string | undefined,
): Promise<AxiosResponse<CVVideo>> => {
  return await axiosClient.get(EndPoints.cvVideos.getCVVideoId(id));
};

export const editCVVideoById = async (
  id: string | undefined,
  payload: AcceptanceCvVideoDto,
): Promise<AxiosResponse<CVVideo>> => {
  return await axiosClient.patch(EndPoints.cvVideos.putCVVideoId(id), payload);
};

export const autoModerateById = async (
  id: string | undefined,
): Promise<AxiosResponse<VideoModerationResultDto>> => {
  return await axiosClient.get(EndPoints.cvVideos.contentModeration(id));
};

export const speechModerationId = async (
  id: string | undefined,
): Promise<AxiosResponse<string[]>> => {
  return await axiosClient.get(EndPoints.cvVideos.speechModerationById(id));
};

export const textModerationId = async (
  id: string | undefined,
): Promise<AxiosResponse<TextModerationResponseDto[]>> => {
  return await axiosClient.get(EndPoints.cvVideos.textModerationById(id));
};
